var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7 13 86 74",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.034 16H16.966A6.974 6.974 0 0 0 10 22.966v53.591a6.974 6.974 0 0 0 6.966 6.966h66.068A6.974 6.974 0 0 0 90 76.557V22.966A6.974 6.974 0 0 0 83.034 16zM13.582 30.499h72.836v38.526H13.582V30.499zm3.384-10.917h66.068a3.388 3.388 0 0 1 3.384 3.384v3.95H13.582v-3.95a3.388 3.388 0 0 1 3.384-3.384zm66.068 60.36H16.966a3.388 3.388 0 0 1-3.384-3.385v-3.95h72.836v3.95a3.388 3.388 0 0 1-3.384 3.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.704 48.148 41.42 36.45a1.793 1.793 0 0 0-2.569 1.614v23.393a1.792 1.792 0 0 0 2.569 1.614l24.284-11.697a1.792 1.792 0 0 0 0-3.227zm-23.27 10.46V40.914l18.365 8.847-18.365 8.845z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoAnalysis);
export default __webpack_public_path__ + "static/media/video-analysis.83d62b1bdd2b54be2d77a1b36c824f74.svg";
export { ForwardRef as ReactComponent };